<template>
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
    <path d="M12.793 4L14.293 2.5L15 3.2055L13.5 4.706L12.793 4ZM8 10.25L5.5 7.7695L6.295 6.9845L8 8.6745L11.705 5L12.5 5.7895L8 10.25Z" :class="containerClass" />
    <path d="M2 14V12.7065L5.207 9.5L4.5 8.7925L2 11.2925V1H1V14C1 14.2652 1.10536 14.5196 1.29289 14.7071C1.48043 14.8946 1.73478 15 2 15H15V14H2Z" :class="containerClass" />
  </svg>
</template>

<script>
export default {
  props: {
    className: {
      type:  [String, Array],
      default: "",
    },
    containerClass: {
      type: String,
      default: "",
    },
  },
};
</script>
